/**
 * Layout related methods
 * -----------------------------------------------------------------------------
 *
 * @namespace layout
 */

import enquire from 'enquire.js';
import axios from 'axios';
import detectIt from 'detect-it';
import tinycolor from 'tinycolor2';
import Flickity from 'flickity';
import videojs from 'video.js';
import 'videojs-youtube/dist/Youtube.min.js';
import 'video.js/dist/video-js.min.css';

var videoPlayer = null;

var layoutMethods = {
  data: function data() {
    return {
      scrollPosition: 0,
      isLogoLight: false,
      isOverlayVisible: false,
      isCartDrawerOpen: false,
      isMobileNavDrawerOpen: false,
      isSearchLayerOpen: false,
      isNewsletterPopupOpen: false
    };
  },


  methods: {
    _initLayout: function _initLayout() {
      window.addEventListener('scroll', app._checkScrollPos); // add scroll event listener
      window.addEventListener('resize', app._initStickyHeader); // add resize event listener

      // make all images in RTE editor load via lazyload
      $('.rte img').addClass('lazyload');

      app._initBootstrapComponents();
      // app._initNewsletterPopup();
      app._initStickyHeader();
      app._initCarousels();
      app._checkScrollPos();
      app._checkCurrencyElements();

      try {
        // init videos
        if ($('.video-js').length > 0) {
          videojs(document.querySelector('.video-js'));
        }
      } catch (error) {
        Rollbar.error("VideoJS has some issues.");
      }
    },
    _initBootstrapComponents: function _initBootstrapComponents() {
      /* Bootstrap components that need to be initialized should be called here */
      // init popover
      $('[data-toggle="popover"]').popover();

      // cart dropdown popover
      $('[data-cart-dropdown]').popover({
        html: true,
        content: function content() {
          return $(this).next('[data-cart-dropdown-content]').html();
        }
      });

      // init tooltip but only for desktop
      if (!detectIt.hasTouch) {
        setTimeout(function () {
          $('[data-toggle="tooltip"]').tooltip();
        }, 100);
      }

      // make navigation drop-downs open on mouse hover instead of click
      $('.navbar a[data-toggle="dropdown"]').on('mouseenter', function (e) {
        var $dropdownLink = $(this).parent();
        var $dropdownMenu = $dropdownLink.find('.dropdown-menu');

        e.currentTarget.setAttribute("aria-expanded", "true");
        $dropdownLink.addClass('show');
        $dropdownMenu.addClass('show');

        $dropdownLink.on('mouseleave', function (event) {
          $(this).removeClass('show');
          $dropdownMenu.removeClass('show');
          event.currentTarget.firstElementChild.setAttribute("aria-expanded", "false");
        });
      });

      // make also the top link clickable
      $('.navbar a[data-toggle="dropdown"]').on('click', function (e) {
        location.href = $(this).attr('data-href');
      });
    },


    // _initNewsletterPopup() {
    //   const customerPosted = (window.location.href.search('[?&]customer_posted=true') !== -1);
    //   const $newsletterPopup = $(app.selectors.newsletterPopup);
    //   const popupDelay = $newsletterPopup.data('popup-delay') * 1000;
    //   const daysUntil = $newsletterPopup.data('period-until');
    //   const newsletterPopupEnabled = $newsletterPopup.data('newsletter-enabled');
    //   const newsletterPopupStatus = app._getCookie('newsletter_popup_status');
    //   const today = new Date();
    //   const expirationDate = new Date();
    //   // expirationDate.setDate(today.getDate() + daysUntil);
    //   expirationDate.setDate('Mon, 01-Jan-2001 00:00:00 GMT');
    //   const time = expirationDate.getTime();
    //   const expireTime = time + 1000 * 36000;
    //   expirationDate.setTime(expireTime);

    //   // after registration get the 'customer_posted' parameter from URL
    //   // show popup after successful registration
    //   // the popup will have the 'Thank you' message after registration redirection
    //   if (customerPosted) {
    //     app._toggleNewsletterPopup();
    //   }

    //   // do not show the popup if the disabled status cookie exists
    //   if (newsletterPopupStatus === 'disabled' || !newsletterPopupEnabled) {
    //     return;
    //   }

    //   setTimeout(() => {
    //     app._toggleNewsletterPopup();
    //   }, popupDelay);

    //   $(document).on('click', '[data-newsletter-close-btn]', () => {
    //     document.cookie = `newsletter_popup_status=disabled;expires=${expirationDate.toGMTString()};path=/`;
    //   });
    // },

    _initStickyHeader: function _initStickyHeader() {
      var $siteHeader = $(app.selectors.siteHeader);
      var $headerSlider = $(app.selectors.headerSlider);
      var $mainNav = $siteHeader.find('nav');
      var $topBar = $siteHeader.find('[data-top-bar]');
      var navHeight = void 0;

      if ($topBar.length > 0) {
        navHeight = $mainNav.outerHeight() + $topBar.outerHeight();
      } else {
        navHeight = $mainNav.outerHeight();
      }

      if ($siteHeader.data('fixed-header')) {
        // boolean
        $('body:not(.template-index) #app').css('padding-top', navHeight);
      } else {
        // $headerSlider.css('height', $headerSlider.outerHeight() - navHeight);
        // remove navHeight
        // $headerSlider.css('height', $headerSlider.outerHeight());
      }
    },


    /**
     * Window scroll info => update classes & elements
     */
    _checkScrollPos: function _checkScrollPos() {
      var $siteHeader = $(app.selectors.siteHeader);
      var $mainNav = $siteHeader.find('nav');
      var $topBar = $siteHeader.find('[data-top-bar]');
      var $navBgColor = $mainNav.css('backgroundColor');
      var isHeaderTransparent = $siteHeader.data('transparent-header');
      var isHomepage = $('body').hasClass('template-index');
      var windowScrollY = window.scrollY;
      var isDarkBg = void 0;
      var navHeight = void 0;

      if ($topBar.length > 0) {
        navHeight = $mainNav.outerHeight() + $topBar.outerHeight();
      } else {
        navHeight = $mainNav.outerHeight();
      }

      if (app.scrollPosition < windowScrollY && app.scrollPosition > navHeight) {
        // direction down
        $('body').removeClass('is-scrolled-top is-scrolled-up').addClass('is-scrolled-down');

        if ($('body').hasClass('is-scrolled-top')) {
          $('header').removeClass('sticky-border');
        } else if ($('body').hasClass('is-scrolled-down') || $('body').hasClass('is-scrolled-up')) {
          $('header').addClass('sticky-border');
        }

        isDarkBg = tinycolor($navBgColor).isDark(); // returns boolean

        if (isDarkBg) {
          app.isLogoLight = true;
        } else {
          app.isLogoLight = false;
        }
      } else {
        // direction up
        $('body').removeClass('is-scrolled-top is-scrolled-down').addClass('is-scrolled-up');

        if ($('body').hasClass('is-scrolled-top')) {
          $('header').removeClass('sticky-border');
        } else if ($('body').hasClass('is-scrolled-down') || $('body').hasClass('is-scrolled-up')) {
          $('header').addClass('sticky-border');
        }

        if (isHomepage && isHeaderTransparent) {
          $mainNav.removeClass('bg-transparent');
        }
        isDarkBg = tinycolor($navBgColor).isDark(); // returns boolean

        if (isDarkBg) {
          app.isLogoLight = false;
        }
      }

      if (windowScrollY <= navHeight) {
        // reached top
        $('body').removeClass('is-scrolled-up').addClass('is-scrolled-top');
        $('header').removeClass('sticky-border');
        if (isHomepage && isHeaderTransparent) {
          $mainNav.addClass('bg-transparent');
          app.isLogoLight = true;
        }
      }

      // hide popover past to 200
      // if (app.scrollPosition > 200){
      //   app.$root.$emit('bv::hide::popover')
      // }

      app.scrollPosition = windowScrollY;
    },
    _initCarousels: function _initCarousels() {
      var $carousel = $(app.selectors.carousel);
      var videoPlayerSlider = void 0;

      $carousel.each(function (index, el) {
        var flkty = Flickity.data(el); // pass in the element, $element[0], not the jQuery object

        if (typeof flkty === 'undefined') {
          return;
        }

        var totalSlides = flkty.cells.length;
        var selectedSlide = flkty.selectedElement;
        var slideType = $(selectedSlide).data('slide-type');

        if (totalSlides === 1) {
          $(el).addClass('hide-nav-ui');
        }

        flkty.on('settle', function () {
          selectedSlide = flkty.selectedElement;
          slideType = $(selectedSlide).data('slide-type');
          checkVideo(slideType);
        });

        flkty.on('change', function (index) {
          if (videoPlayerSlider) {
            videoPlayerSlider.pause();
          }
        });

        function checkVideo(slideType) {
          if (slideType !== 'video') {
            return;
          }
          videoPlayerSlider = videojs($(selectedSlide).find('.video-js')[0]);
          videoPlayerSlider.play();
        }

        checkVideo(slideType);
        flkty.resize();
        app._triggerResize();
      });
    },
    _initVideo: function _initVideo(selectedSlide) {
      var $selectedVideo = $(selectedSlide).find('[data-video-slide]');
      var selectedVideoId = $selectedVideo.data('video-id');

      if (!selectedVideoId) {
        return;
      }

      function onPlayerReady(e) {
        e.target.setPlaybackQuality('hd720');
        e.target.mute();
        e.target.playVideo();
      }

      function onPlayerStateChange(e) {
        if (e.data === YT.PlayerState.ENDED) {
          // console.log('video finished');
        }
      }

      enquire.register('screen and (min-width: 720px)', {
        match: function match() {
          YouTubeIframeLoader.load(function (YT) {
            videoPlayer = new YT.Player($selectedVideo[0], {
              videoId: selectedVideoId,
              width: '100%',
              height: '100%',
              playerVars: {
                enablejsapi: 1,
                autoplay: 1,
                loop: 1,
                playlist: selectedVideoId, // otherwise loop will not work
                rel: 0,
                controls: 0,
                showinfo: 0,
                modestbranding: 0,
                disablekb: 1
                // 'start': 0,
                // 'end': 335,
              },
              events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange
              }
            });
          });
        },
        unmatch: function unmatch() {
          if (videoPlayer) {
            videoPlayer.destroy();
          }
        }
      });
    },


    /**
     * Event when variant quantity selector changes
     */
    _updateQty: function _updateQty(event) {
      console.log(event.currentTarget);
      var $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
      var qtyValue = $qtyEl.val();
      var $item = $(event.currentTarget).closest(app.selectors.cartItem);
      var variantId = $item.data('variant-id');
      var cartProduct = app.cart.items.find(function (x) {
        return x.variant_id === variantId;
      });
      var productCartLimit = $item.data('cart-limit');

      if ($(event.currentTarget).data('qty-decrease') !== undefined) {
        if (parseFloat(qtyValue) >= 2) {
          qtyValue = parseFloat(qtyValue) - 1;
        }
      } else if ($(event.currentTarget).data('qty-increase') !== undefined) {
        qtyValue = parseFloat(qtyValue) + 1;

        // check if item has product limit assigned
        if (app.currentTemplate === 'cart' && app._productHasCartLimit(qtyValue, productCartLimit)) {
          return;
        }
      }

      $qtyEl.val(qtyValue);
    },


    /**
     * Event for toggling the cart drawer
     *
     */
    _toggleCartDrawer: function _toggleCartDrawer() {
      if (app.currentTemplate === 'cart') {
        return;
      }

      var $siteOverlay = $(app.selectors.siteOverlay);
      var cartType = $(app.selectors.siteHeader).data('cart-type');

      // stop parsing if cart type is not set to 'drawer'
      if (cartType !== 'cart_drawer') {
        return;
      }

      if (!app.isCartDrawerOpen) {
        // open drawer

        app.isOverlayVisible = true;
        app._lockScroll();

        // re-init tooltips but only for desktop
        if (!detectIt.hasTouch) {
          $('[data-toggle="tooltip"]').tooltip();
        }
      } else {
        app.isOverlayVisible = false;
        app._unlockScroll();
      }

      // toggle the status data
      app.isCartDrawerOpen = !app.isCartDrawerOpen;

      $siteOverlay.on('click', function () {
        if (app.isSearchLayerOpen) {
          return;
        }
        app._toggleCartDrawer();
      });

      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.isCartDrawerOpen) {
          return;
        }
        e = e || window.event;
        if (e.keyCode === 27) {
          app._toggleCartDrawer();
        }
      });
    },


    /**
     * Event for toggling the mobile menu drawer
     *
     */
    _toggleMobileNavDrawer: function _toggleMobileNavDrawer() {
      var $siteOverlay = $(app.selectors.siteOverlay);

      if (!app.isMobileNavDrawerOpen) {
        // open drawer
        app.isOverlayVisible = false;
        app._lockScroll();
      } else {
        app.isOverlayVisible = false;
        app._unlockScroll();
      }

      // toggle the status data
      app.isMobileNavDrawerOpen = !app.isMobileNavDrawerOpen;
      $('.mobile-nav-drawer .dropdown.open').each(function () {
        $(this).removeClass('open');
        $(this).find('.submenu').removeClass('open');
      });
      if (app.isMobileNavDrawerOpen === true) {
        var headerHeight = $('#shopify-section-header').outerHeight(true) + $('#shopify-section-topbar-mobile').outerHeight(true);
        $('.mobile-nav-drawer').css('top', headerHeight - 1);
      } else {
        $('.mobile-nav-drawer').css('top', 0);
      }

      $siteOverlay.on('click', function () {
        if (!app.isMobileNavDrawerOpen) {
          return;
        }
        app._toggleMobileNavDrawer();
      });
    },
    _opensubMenu: function _opensubMenu(event) {
      var id = $(event.currentTarget).attr('data-target');
      var dropdownParent = $(id);
      app._dropdownToggle(dropdownParent);
    },
    _dropdownToggle: function _dropdownToggle(dropdownParent) {
      var isActive = dropdownParent.hasClass('open');
      setTimeout(function () {
        if (!isActive) {
          app._dropdownShow(dropdownParent);
        } else if (isActive) {
          app._dropdownHide(dropdownParent);
        }
      }, 50);
    },
    _dropdownShow: function _dropdownShow(dropdownParent) {
      app._toggleElement(dropdownParent, 'open');
    },
    _toggleElement: function _toggleElement(container, activity) {
      if (!container) return;
      if (activity == 'open') {
        $(container).addClass('open');
        $(container).closest('.dropdown').addClass('open');
      } else {
        $(container).removeClass('open');
        $(container).closest('.dropdown').removeClass('open');
      }
    },
    _dropdownHide: function _dropdownHide(dropdownParent) {
      if (!dropdownParent) {
        return;
      }

      if (!dropdownParent.closest('[data-role="drawer"]')) {
        dropdownParent.removeClass('open');
      } else {
        app._toggleElement(dropdownParent, 'close');
      }
      if (dropdownParent.closest('.dropdown')) {
        dropdownParent.closest('.dropdown').removeClass('open');
      }

      var childDropdowns = dropdownParent.find('.dropdown.open');
      if (childDropdowns.length > 0) {
        childDropdowns.forEach(function (child) {
          child.removeClass('open');
        });
      }
    },


    /**
     * Event for toggling the search layer
     *
     */
    _toggleSearch: function _toggleSearch() {
      var $searchLayer = $(app.selectors.searchLayer);
      var searchType = $searchLayer.data('search-type');
      var $inputSearch = $searchLayer.find('#searchInput');

      if (!app.isSearchLayerOpen) {
        $inputSearch.val('');
        app._lockScroll();
        $('body').addClass('search_open');
        if (searchType === 'full_screen') {
          $('[data-product-toolbar-mobile]').hide();
        } else {
          app.isOverlayVisible = true;
        }

        setTimeout(function () {
          $inputSearch.focus();
        }, 500);
      } else {
        $inputSearch.blur();
        app._unlockScroll();
        $('body').removeClass('search_open');
        if (searchType === 'full_screen') {
          $('[data-product-toolbar-mobile]').show();
        } else {
          app.isOverlayVisible = false;
        }
      }

      if (searchType === 'type_3') {
        app.isOverlayVisible = false;
      }

      // toggle the status data
      app.isSearchLayerOpen = !app.isSearchLayerOpen;

      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.isSearchLayerOpen) {
          return;
        }
        e = e || window.event;
        if (e.keyCode === 27 && app.isSearchLayerOpen) {
          app._toggleSearch();
        }
      });
    },


    /**
     * Cusrom search
     *
     */
    _customSearch: function _customSearch(event) {
      var $form = $(event.currentTarget).closest('form');
      var newLocal = '#searchInput';
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      var $input = $form.find(newLocal).val().replace(' ', '-');
      var url = '/search?q=' + $input;
      window.location.href = url;
    },


    /**
     * Event for toggling the newsletter popup
     *
     */
    _toggleNewsletterPopup: function _toggleNewsletterPopup() {
      if (!app.isNewsletterPopupOpen) {
        app._lockScroll();
        app.isOverlayVisible = true;
      } else {
        app._unlockScroll();
        app.isOverlayVisible = false;
      }

      // toggle the status data
      app.isNewsletterPopupOpen = !app.isNewsletterPopupOpen;
    },


    /**
     * Lock window scroll
     *
     */
    _lockScroll: function _lockScroll() {
      $('html').css('overflow', 'hidden');

      $(document).on('touchmove', function (e) {
        if (!$(e.target).closest('[data-touch-moveable]').length) {
          e.preventDefault();
        }
      });
    },


    /**
     * Unlock window scroll
     *
     */
    _unlockScroll: function _unlockScroll() {
      $('html').css('overflow', 'auto');
      $(document).unbind('touchmove');
    },
    _changeCurrency: function _changeCurrency() {
      var $currencyForm = $('[data-currency-selector]');
      $currencyForm[0].submit();
    },


    /**
     * Recharge Integration => Attach Recharge widget dynamically
     */
    _attachRechargeWidget: function _attachRechargeWidget(productId) {
      // recharge widget
      var $subscriptionWidget = $('[data-recharge-subscription-widget="' + productId + '"]');
      var $rcContainer = $('#recurring_choice_' + productId);

      if ($rcContainer.length > 0) {
        $subscriptionWidget.find('.inner').append($rcContainer);
        $subscriptionWidget.show();
        $rcContainer.show();
      }
    },


    /**
     * Recharge Integration => Detach Recharge widget dynamically
     */
    _detachRechargeWidget: function _detachRechargeWidget(productId) {
      // recharge widget
      var $subscriptionWidget = $('[data-recharge-subscription-widget="' + productId + '"]');
      var $rcContainer = $('#recurring_choice_' + productId);
      var $ghostPlaceholder = $('[data-recharge-ghost-placeholder]');

      if ($rcContainer.length > 0) {
        // reset recharge widget form to first options
        $('[data-input-one-time]').trigger('click');
        $subscriptionWidget.find('select').prop('selectedIndex', 0);
        // remove subscription properties
        $('[name="properties[subscription_id]"]').remove();
        // put back
        $ghostPlaceholder.append($rcContainer);
        $subscriptionWidget.find('.inner').empty();
        $subscriptionWidget.hide();
        $rcContainer.hide();
      }
    }
  }
};

export default layoutMethods;